<div
    class="ellipsis-tooltip-text"
    [ngClass]="{ 'overflow-ellipsis': isOverflowing }"
    cdkOverlayOrigin
    #contentDiv
    #overlay="cdkOverlayOrigin"
    (mouseenter)="checkOverflow(true)"
    (mouseleave)="isTooltipOpen = false"
>
    {{ text | translate }}
    <fcp-tooltip [open]="isTooltipOpen" [overlayOrigin]="overlay" [customPosition]="tooltipPosition">
        <span class="fc-article-card-main-attribute-error-message"> {{ text }} </span>
    </fcp-tooltip>
</div>

<ng-template #linkTemplate>
    <ng-content></ng-content>
</ng-template>
